import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { fromStore } from '../../../selectors';
import cn from 'classnames';
import Loader from '../../../components/utils/Loader';
import { isEmpty } from 'lodash';
import { ItemRow } from './ItemRow';
import { TableHeader } from './TableHeader';
import { useDispatch } from 'react-redux';
import { fetchSliders } from '../../../action';
import ReactTooltip from 'react-tooltip';
import { styles } from '../styles';

export function SlidersList() {
    const dispatch = useDispatch();
    const loaderList = useSelector(fromStore.loaderSlidersSelector);
    const sliders = useSelector(fromStore.slidersListSelector);

    useEffect(() => ReactTooltip.rebuild(), [sliders, loaderList]);

    useEffect(() => {
        isEmpty(sliders) && dispatch(fetchSliders());
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [dispatch]);

    return (
        <div className="kt-container  kt-container--fluid  kt-grid__item kt-grid__item--fluid" style={{ padding: 0 }}>
            <div className="kt-portlet kt-portlet--mobile">
                <div className="kt-portlet__body kt-portlet__body--fit">
                    <div
                        style={{ position: 'relative', marginBottom: 0 }}
                        className={
                            cn('kt-datatable kt-datatable--default kt-datatable--brand kt-datatable--loaded', {
                                'kt-datatable--error': isEmpty(sliders)
                            })
                        }>
                        {loaderList && <div style={styles.tableLoading}><Loader text='Загружаю данные'/></div>}
                        <table className="kt-datatable__table" style={{ minHeight: '700px' }}>
                            {window.innerWidth >= 850 && <TableHeader />}
                                <tbody className="kt-datatable__body">
                                    {
                                        loaderList
                                            ? null
                                            : isEmpty(sliders)
                                                ? <tr><td colSpan={8}><span className="kt-datatable--error">Слайдеров пока нет</span></td></tr>
                                                : sliders.map((item) => <ItemRow key={item.id} item={item} />)
                                    }
                                </tbody>
                        </table>
                    </div>
                </div>
            </div>
            <ReactTooltip
                effect="solid"
                type="dark"
                place="top"
            />
        </div>
    );
}